module.exports = __webpack_public_path__ + "static/media/musicology-black.a24653af.png";